/* eslint-disable react-hooks/exhaustive-deps */
import {Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import { useAppKit } from '@reown/appkit/react'
import {ethers} from 'ethers'
import {getDataForChain} from '../../../utils/index.js'
import {toast} from "react-toastify";
import {Modal2} from "../../../components/Modal/index.jsx";
import "./qoStyles.css"
import {NFTDeployerABI} from "../../../abi/NFTDeployer.js";
import {AMNAbi} from "../../../abi/AuctionManagerNew.js";
import {ERC20Factory} from "../../../abi/ERC20Factory.js";

/**
 * ManageDeployer component.
 *
 * Comprehensive management interface for deployed NFT collections.
 * Handles deployment and configuration of:
 * - NFT collection contracts (ERC721)
 * - Auction manager settings
 * - ERC-20 token for rewards
 * - Reward manager (RM) implementation
 * - Admin list management
 * - Treasury extraction
 *
 * Features:
 * - Deploy new collection or manage existing
 * - Configure auction parameters (fees, durations)
 * - Set up reward manager with epochs
 * - Mint reflection percentages
 * - Whitelist management
 * - Interactive modals for complex operations
 *
 * @param {Object} props - Component props
 * @param {Function} props.clickCallback - Handler to switch form view
 * @param {Object} props.cInfo - Collection data from database or form
 * @returns {React.ReactElement} Deployer management interface
 */
const ManageDeployer = ({clickCallback, cInfo}) => {
    //  const [isRoyal, sIR] = useState()
    //  const [isRefl, sRFL] = useState()
    const {wallet, open, close} = useAppKit()
    const [payees, sPay] = useState([{id: 0, address: wallet?.accounts[0]?.address, percentage: 100}])
    const [upd, sUpd] = useState(0)
    const [showModal, ssm] = useState(false);
    const [modalContent, smc] = useState();
    const [modalTitle, smt] = useState()
    const [chain, setChain] = useState()
    const [defRMImp, setDRI] = useState();
    const [defImp, setIMP] = useState();

    let earlyFinPercentage = 0;
    let salesPercentage = 0;
    let removalBiddersPercentage = 0;
    let nextMinBid = 0;
    let nftDelegatorAddr = ""

    let e20_en;
    let e20_fee;
    let e20_imp;

    let amContract;
    let erc20Fctr;

    //const [whitelist, swl] = useState([])


    // if(wallet){
    //     let cd = getDataForChain(wallet?.chains[0]?.id);
    //     console.log("cd:", wallet?.chains[0]?.id, cd);
    //     setChain(cd)
    // }

    let item = cInfo;

    const addPayee = () => {
        let ppInfo = payees;
        ppInfo.push({id: payees.length, address: "Address", percentage: 100})
        sPay(ppInfo)
        sUpd(Math.random())
    }

    const delPayee = (id) => {
        let ppInfo = payees;
        let tmp = [];
        let ct = 0;

        for (let i = 0; i < ppInfo.length; i++) {
            if (ppInfo[i].id !== id) {
                ppInfo[i].id = ct;
                tmp.push({id: ct, address: ppInfo[i].address, percentage: ppInfo[i].percentage})
                ct++;
            }
        }

        sPay(tmp)
        sUpd(Math.random())
    }

    // let sup;
    // let hdb = [
    //     ""
    // ]

    function helpToast(e) {

        let help = {
            dele: <><b>Delegator Address</b><br/>
                <div className="small helptoast">The address of a contract which holds all funds on behalf of the Auction
                    Manager contract, in doing so, delegating them to a FTSO provider. If the address is set to 0x0 then no delegator
                    contract is used.
                </div>
            </>,
            mp: <><b>Mint Price </b><br/>
                <div className="small helptoast">The price you are charging per token. This can be adjusted at any time.
                    Note that this is expressed in native tokens, and not "wei", so if you're charging 100 SGB, for
                    example, just enter 100.
                </div>
            </>,
            c20: <><b>ERC20 Deployment cost</b><br/>
                <div className="small helptoast">The amount in wei it costs to deploy an ERC20 token on the current network.
                </div>
            </>,
            rlb: <><b>Removal Fee %</b><br/>
                <div className="small helptoast">This is the penalty a seller is charged if they decide to remove a listing
                    which has open bids. The high bidder is refunded and compensated, and the item is returned to the seller's custody. If the high bid was
                    100, the seller would have to pay 25 to the marketplace to remove the listing. 12.5 would go to the high bidder and
                    12.5 to the marketplace. The reason for this penalty is that cancelling a running auction amounts to a breach of
                    contract between both the seller and the mp, as well as the seller and the bidder.
                </div>
            </>,
            sfee: <><b>Sales fee %</b><br/>
                <div className="small helptoast">Amount the marketplace currently charges for sales of any listed item.
                    The amount is split between the buyer and the seller, so if percentage is 5, and item is 100, buyer
                    pays 102.5, and seller receives 97.5.
                </div>
            </>,
            nbp: <><b>Minimum Next-Bid %</b><br/>
                <div className="small helptoast">When a bidder wants to outbid the previous bidder, this is the minimum amount
                    the marketplace will accept for the bid. In percentage. So if bid 1 is 100 and percentage is 5 then next min bid will be 105.
                </div>
            </>,
            ef: <><b>Early Finalization Fee:</b><br/>
                <div className="small helptoast">This is the fee taken by the marketplace (as a percentage) from the current bid on an
                    auction item when the seller decides to finish the auction before its deadline.
                </div>
            </>,
            mpf: <><b>Marketplace Fee:</b><br/>
                <div className="small helptoast">This is the percentage that the marketplace takes from the total amount
                    paid for each minted item.
                </div>
            </>,
            roy: <><b>Max Royalty allowed:</b><br/>
                <div className="small helptoast">This is the percentage that the marketplace takes from the total amount
                    paid for each minted item.
                </div>
            </>,
            di: <><b>Default ERC721 Implementation:</b><br/>
                <div className="small helptoast">The implementation contract address to be used for deploying new
                    ERC721 collections. This must be a UUPS compliant contract.
                </div>
            </>,
            ri: <><b>Default RM Implementation:</b><br/>
                <div className="small helptoast">The implementation contract address to be used for deploying new
                    rewardManager instances. This must be a UUPS compliant contract, and if used with the default ERC721
                    implementation, it must implement the required bindings for reward calculations to be triggered.
                </div>
            </>,
            ncf: <><b>NFTConfigurator Address:</b><br/>
                <div className="small helptoast">The address of the contract responsible for managing the configuration
                    variables for contracts deployed on this chain. Works with the reference ERC721 implementation only.
                </div>
            </>,
        }


        toast.info(help[e.target.id], {autoClose: 15000});
    }

    useEffect(() => {
        if (chain?.data?.chainName) {
            getInfo();
        }
    }, [upd, chain])

    // useEffect(() => {
    //     //getInfo()
    // }, [chain])

    useEffect(() => {
        if (wallet) {
            setChain(getDataForChain(wallet?.chains[0]?.id))
            //getInfo()
        }
    }, [wallet])

    useEffect(() => {
        if (wallet) {
            setChain(getDataForChain(wallet?.chains[0]?.id))
            getInfo()
        }
    }, [])

    let reflection = true;

    const dContracts = [];
    dContracts["0x10"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd"; // 16 / SGBT
    dContracts["0x13"] = "0x6f76e264C0b4170A1f403E066432d93bF12552Fd";
    dContracts["0x" + parseInt(114).toString(16)] = "0x1"

    const abi = [
        'function newERC721(string TokenName, string Symbol, address collectionOwner, string baseURI, uint256 defMintFee)',
        'function newND721((string tname,string symbol,uint256 maxsupp,uint256 rpool,uint256 secroy,string tokuri,uint256 price,uint256 flags,address owner,uint256 wldiscount,address impl,address rmimpl))',
        'function defImplementation() view returns(address)',
        'function defRMImplementation() view returns(address)',
        'function usersTokensLen(address) view returns(uint256 count)',
        'function freeMintNFT(uint256, address, uint256[])',
        'function tokensByAddress(address) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl)[])',
        'function tokenByAddress(address, uint256) view returns (tuple(address NFTProxyAddr, address RMProxyAddrstring, string tokenName, string tokenSymbol, string tokenType, address NFTImpl, address RMImpl))',
        'function _MINT_PRICE() view returns(uint256)',
        'function _baseTokenURI() view returns(string)',
        'function fe() view returns(tuple(bool extMintHook, bool bonusERC721, bool rmEnabled, bool rmEnabledStk, bool autoDelegation, bool randomMinting, bool softStaking, bool extPrice, bool presaleReduction))',
        'function cfg() view returns(tuple(uint256 MAX_SUPPLY, uint256 RewardsPoolPercent, uint256 secSalesRoyalty, uint256 _MINT_PRICE, uint256 WLDiscount, address RMAddress, address Staking, address Wnat, address FTSORM, address NFTDelegator, address BonusToken, bool isDisabled, address extPriceAddress))',
        'function str() view returns(tuple(string TokenURI, string ContractState, string epFunction, string btFunction))',
        'function setDefImpl(addres a, address b)',
        'function owner() view returns(address owner)',
        'function NFTConfiguratorAddr() view returns(address)'
    ];


    //const abi = _NDNFT;

    if (!wallet) {
        toast.error("Connect wallet first!")
    }


    const getInfo = async () => {
        if (!wallet) {
            toast.error("Connect wallet first!")
            return;
        }

        if (chain) {
            // const dButton = document.getElementById("deployEVM");
            //dButton.disabled = true;
            //dButton.innerText = "Attempting to deploy, please wait";
            //const options = {value: "0", gasLimit: 8000000}
            // let address = dContracts[wallet.chains[0].id];
            let signer = (new ethers.providers.Web3Provider(wallet.provider)).getSigner()
            //const cHid = document.getElementById("_chainName")

            let cdat = chain?.data;


            //let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);

            //toast("selected chain: "+cdat.chainName)
            const contract = new ethers.Contract(cdat?.nftDeployer, abi, signer);
            amContract = new ethers.Contract(cdat?.aManager, AMNAbi, signer);
            try {
                erc20Fctr = new ethers.Contract(cdat?.erc20Factory, ERC20Factory.abi, signer);
            } catch (e) {
            }
            //const rcontract = new ethers.Contract(cInfo.NFTProxyAddr, abi, caller);
            //await contract.deployed();

            let impl = await contract.defImplementation();
            setIMP(impl);
            let rmimpl = await contract.defRMImplementation();
            setDRI(rmimpl);
            let nftc = await contract.NFTConfiguratorAddr();

            try {
                e20_en = await erc20Fctr.deploymentEnabled();
                e20_fee = (await erc20Fctr.deploymentFee()).toString();
                e20_imp = await erc20Fctr.defImpCtr();
            } catch (e) {
            }

            //let cfg = await rcontract.cfg()
            // let str = await rcontract.str()
            window.amc = amContract;


            document.getElementById("_dic").value = impl;
            document.getElementById("_drm").value = rmimpl;
            document.getElementById("_ncf").value = nftc;

            document.getElementById("_e20_en").checked = e20_en;
            document.getElementById("_e20_fee").value = e20_fee;
            document.getElementById("_e20_imp").value = e20_imp;



            nextMinBid = await amContract.nextBidMinPercentage();
            removalBiddersPercentage = await amContract.removeListingFeePercentage()
            earlyFinPercentage = await amContract.earlyFinalizeFeePercentage()
            salesPercentage = await amContract.salesFeePercentage()
            nftDelegatorAddr = await amContract.DelegatorAddress()


            document.getElementById("_am_nb").value = nextMinBid;
            document.getElementById("_am_sf").value = salesPercentage;
            document.getElementById("_am_rf").value = removalBiddersPercentage
            document.getElementById("_am_ef").value = earlyFinPercentage;
            document.getElementById("_am_nd").value = nftDelegatorAddr;
            // document.getElementById("_wlRed").value = cfg.WLDiscount;
            //document.getElementById("sup").innerText = await rcontract.totalSupply() + " of " + cfg.MAX_SUPPLY;
            //console.log(await rcontract.fe(), cfg, str)
        }

    }

    async function updateAMFees() {
        let set_nm = document.getElementById("_am_nb").value;
        let set_sp = document.getElementById("_am_sf").value;
        let set_rf = document.getElementById("_am_rf").value;
        let set_ef = document.getElementById("_am_ef").value;
        let set_nd = document.getElementById("_am_nd").value;

        const txOptions = { value: 0, gasLimit: 8000000 };

        try {
            if (set_nm !== nextMinBid) {
                await amContract.setFee("nextBidMin", set_nm, txOptions);
            }
            if (set_sp !== salesPercentage) {
                await amContract.setFee("salesFee", set_sp, txOptions);
            }
            if (set_rf !== removalBiddersPercentage) {
                await amContract.setFee("removeListing", set_rf, txOptions);
            }
            if (set_ef !== earlyFinPercentage) {
                await amContract.setFee("earlyFinalize", set_ef, txOptions);
            }
            if (set_nd !== nftDelegatorAddr) {
                await amContract.setDelegator(set_nd, txOptions);
            }

            toast.success("Fees updated successfully");
            // Refresh values after successful update
            await getInfo();
        } catch (error) {
            console.error("Error updating fees:", error);
            toast.error(`Error updating fees: ${error?.reason || error?.message || 'Unknown error'}`);
        }
    }

    async function updateERC20() {
        let set_en = document.getElementById("_e20_en").checked;
        let set_fee = document.getElementById("_e20_fee").value;
        let set_imp = document.getElementById("_e20_imp").value;

        const txOptions = { value: 0, gasLimit: 8000000 };

        try {
            if (set_en !== e20_en) {
                await erc20Fctr.SetPubDeployment(set_en, txOptions);
            }
            if (set_fee !== e20_fee) {
                await erc20Fctr.SetDeploymentFee(set_fee, txOptions);
            }
            if (set_imp !== e20_imp) {
                await erc20Fctr.SetDefImpl(set_imp, txOptions);
            }

            toast.success("ERC20 settings updated successfully");
            await getInfo();
        } catch (error) {
            console.error("Error updating ERC20 settings:", error);
            const reason = error?.reason?.replace("!auth", "You are not authorized to make changes to this contract");
            toast.error(<><b>Error:</b><br/>Reason: {reason || error.message}</>);
        }


    }


    async function getDeployerConfig(){

    }
    async function doSettings() {
        let signer = (new ethers.providers.Web3Provider(wallet?.provider)).getSigner()
        let cdat = chain?.data;
        // let caller = new ethers.providers.JsonRpcProvider(cdat.rpc);
        const contract = new ethers.Contract(cdat?.nftDeployer, NFTDeployerABI, signer);
        //const rcontract = new ethers.Contract(cInfo.NFTProxyAddr, abi, caller);
        //await contract.deployed();
        let impl = document.getElementById("_dic").value
        let rmimpl = document.getElementById("_drm").value
        let owner = await contract.owner();
        if (wallet?.accounts[0]?.address?.toLowerCase() !== owner.toLowerCase()) {
            toast.error(<div style={{wordBreak: "break-word", maxWidth: "100%"}}>Only the owner of the NFTDeployer
                contract is able to make changes here.<br/><br/>Owner:<br/>
                <div style={{wordBreak: "break-all", maxWidth: "100%"}}>{owner}</div>
            </div>, {autoClose: 15000})
        } else {
            const options = {value: "0", gasLimit: 8000000}
            await contract.setDefImpl(impl, rmimpl, options)
                .then(() => {
                    toast.success("Changes committed");
                })
                .catch((e) => {
                    toast.error(<>Error in transaction: <div
                        style={{wordBreak: "break-all", maxWidth: "100%"}}>{JSON.stringify(e)}</div></>)
                })
        }
    }

    function InputBox({input_id, button_id, top_text, placeholder_text, callback_fn, posClass, type}) {

        return (

            <div className={posClass} style={{
                marginTop: "6px",
                flexGrow: 1,
                minHeight: "40px"
            }}>
                <span style={{display: "block", position: "absolute", marginTop: "-8px"}}
                      className="text-light input-title">{top_text}</span>
                <div style={{maxWidth: "100%", minWidth: "200px", display: "flex", flexGrow: 1}}>
                    <input id={input_id} style={{width: "100%"}}
                           className={type === "checkbox" ? "" : "input-purple"} name={"icost"}
                           placeholder={placeholder_text}
                           type={type ?? "number"}/>
                    <button id={button_id} onClick={(e) => callback_fn(e)} style={{width: "32px"}}
                            className="help-purple">?
                    </button>
                </div>
            </div>
        );
    }


    return (
        <div className="card card-purple p-1">
            <Modal2 show={showModal} modalTitle={modalTitle} content={modalContent}/>
            <span className="text-light input-title">Managing Deployment Suite: ({chain?.data?.chainName})</span>

            <div id="_cName" style={{
                style: "flex",
                flexDirection: "column",
                position: "relative",
                width: "100%",
                fontSize: "20px",
                textAlign: "center"
            }} className="w-100 raisedBoxPurple">
                <div>NFTDeployer ({chain?.data?.nftDeployer})</div>
            </div>
            <div style={{display: "flex", flexDirection: "column", width: "100%"}} className="raisedBoxPurple">
                <div style={{
                    border: "0px inset green",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative"
                }}>
                    <div style={{flex: 1, alignSelf: "center", fontSize: "20px"}}>Deployer Setup</div>
                    {/*       <div className="optsDropdown">
                        <QuickOptions smc={smc} smt={smt} ssm={ssm} item={item}/>
                    </div>*/}
                </div>
                <span className="text-light input-title">Default Implementation Contract:</span>
                <div style={{maxWidth: "100%", display: "flex", flexGrow: 1}}>
                    <input id="_dic" style={{flexGrow: 1}} className="input-purple" name={"collInf"}
                           placeholder={"Implementation contract address"}/>
                    <button id="di" onClick={(e) => helpToast(e)} style={{height: "40px", width: "32px"}}
                            className="help-purple">?
                    </button>
                </div>

                <span className="text-light input-title">Default RM Implementation Ctr:</span>
                <div style={{maxWidth: "100%", display: "flex"}} className="mb-2">
                    <input id="_drm" style={{flexGrow: 1, minWidth: "30%"}} className="input-purple" name="juri"
                           placeholder={"RM impl ctr addr"}/>
                    <button id="ri" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                            className="help-purple">?
                    </button>
                </div>

                <span className="text-light input-title">NFTConfigurator Address:</span>
                <div style={{maxWidth: "100%", display: "flex"}} className="mb-2">
                    <input id="_ncf" style={{flexGrow: 1, minWidth: "30%"}} className="input-purple" name="juri"
                           placeholder={"NFTConfigurator Address"}/>
                    <button id="ncf" onClick={(e) => helpToast(e)} style={{width: "32px"}}
                            className="help-purple">?
                    </button>
                </div>

                <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                    {/*<InputBox callback_fn={helpToast} button_id={"rp"} input_id={"_itemCost"}
                              posClass={"nftFormNumInput nni-l"} top_text={"Royalties:"} placeholder_text={""}/>*/}
                    <InputBox callback_fn={helpToast} button_id={"mpf"} input_id={"_wlRed"}
                              posClass={"nftFormNumInput nni-r"} top_text={"MP Fee %:"}
                              placeholder_text={"Default marketplace fee"}/>
                </div>
                <button onClick={() => doSettings()}
                        className="btn btn-outline-danger text-white w-100 mt-2 mb-0">Update Settings
                </button>
            </div>
            <div style={{display: "flex", flexDirection: "column", width: "100%"}} className="raisedBoxPurple">
                <div
                    style={{border: "0px inset green", display: "flex", flexDirection: "column", position: "relative"}}>
                    <div style={{flex: 1, alignSelf: "center", fontSize: "20px"}}>AuctionManager Setup</div>
                </div>

                <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                    <InputBox callback_fn={helpToast} button_id={"sfee"} input_id={"_am_sf"}
                              posClass={"nftFormNumInput nni-l"}
                              top_text={"Sales Fee % (split between buyer and seller):"}
                              placeholder_text={"Sales fee %"}/>
                    <InputBox callback_fn={helpToast} button_id={"ef"} input_id={"_am_ef"}
                              posClass={"nftFormNumInput nni-r"} top_text={"Early finalization fee %"}
                              placeholder_text={"Early finalization %"}/>
                    <InputBox callback_fn={helpToast} button_id={"rlb"} input_id={"_am_rf"}
                              posClass={"nftFormNumInput nni-l"} top_text={"Removal of listing with bidders fee %:"}
                              placeholder_text={"Removal with bidders fee %"}/>
                    <InputBox callback_fn={helpToast} button_id={"nbp"} input_id={"_am_nb"}
                              posClass={"nftFormNumInput nni-r"} top_text={"Minimum next-bid percentage:"}
                              placeholder_text={"Min Next Bid %"}/>
                    <InputBox callback_fn={helpToast} type="text" button_id={"dele"} input_id={"_am_nd"}
                              posClass={"nftFormNumInput nni-l"} top_text={"NFTDelegator Address"}
                              placeholder_text={"NFTDelegator Address"}/>
{/*                    <InputBox callback_fn={helpToast} button_id={"re"} input_id={"_am_nb"}
                              posClass={"nftFormNumInput nni-r"} top_text={"Minimum next-bid percentage:"}
                              placeholder_text={"Min Next Bid %"}/>*/}
                </div>

                <button onClick={() => updateAMFees()}
                        className="btn btn-outline-danger text-white w-100 mt-2 mb-0">Update Settings
                </button>
            </div>

            <div style={{display: "flex", flexDirection: "column", width: "100%"}} className="raisedBoxPurple">
                <div
                    style={{border: "0px inset green", display: "flex", flexDirection: "column", position: "relative"}}>
                    <div style={{flex: 1, alignSelf: "center", fontSize: "20px"}}>ERC20 Deployer Setup</div>
                </div>

                <div style={{display: "flex", flexDirection: "row", flexWrap: "wrap", minWidth: "100%"}}>
                    <InputBox callback_fn={helpToast} button_id={"rp"} input_id={"_e20_en"}
                              posClass={"nftFormNumInput nni-l"}
                              top_text={"Enable Pub Deploys:"}
                              placeholder_text={"Sales fee %"} type={"checkbox"}/>
                    <InputBox callback_fn={helpToast} button_id={"c20"} input_id={"_e20_fee"}
                              posClass={"nftFormNumInput nni-r"} top_text={"Deploy Cost In Wei"}
                              placeholder_text={"Deploy Cost In Wei"} type={"number"}/>
                    <InputBox callback_fn={helpToast} button_id={"re"} input_id={"_e20_imp"}
                              posClass={"nftFormNumInput nni-r"} top_text={"Implementation Contract"}
                              placeholder_text={"0xAddress"} type={"text"}/>
                    {/*<InputBox callback_fn={helpToast} button_id={"rp"} input_id={"_am_rf"}*/}
                    {/*          posClass={"nftFormNumInput nni-l"} top_text={"Removal of listing with bidders fee %:"}*/}
                    {/*          placeholder_text={"Removal with bidders fee %"}/>*/}
                    {/*<InputBox callback_fn={helpToast} button_id={"re"} input_id={"_am_nb"}*/}
                    {/*          posClass={"nftFormNumInput nni-r"} top_text={"Minimum next-bid percentage:"}*/}
                    {/*          placeholder_text={"Min Next Bid %"}/>*/}
                    {/*<InputBox callback_fn={helpToast} type="text" button_id={"rp"} input_id={"_am_nd"}*/}
                    {/*          posClass={"nftFormNumInput nni-l"} top_text={"NFTDelegator Address"}*/}
                    {/*          placeholder_text={"NFTDelegator Address"}/>*/}
                    {/*<InputBox callback_fn={helpToast} button_id={"re"} input_id={"_am_nb"}*/}
                    {/*          posClass={"nftFormNumInput nni-r"} top_text={"Minimum next-bid percentage:"}*/}
                    {/*          placeholder_text={"Min Next Bid %"}/>*/}
                </div>

                <button onClick={() => updateERC20()}
                        className="btn btn-outline-danger text-white w-100 mt-2 mb-0">Update Settings
                </button>
            </div>

            <div className="px-2">

                {/*<Button id="deployEVM" onClick={(event) => deployEVM(event.target.id)}*/}
                {/*        className="btn bg-gradient-dark w-100 my-4 mb-2">Deploy</Button>*/}
                <Button id="def" onClick={() => clickCallback("def")}
                        className="btn bg-gradient-dark w-100 my-4 mb-2">Back</Button></div>

        </div>
    );
}

export {ManageDeployer};